import { COLORS } from "../../common/constants";

const styles = {
  mainContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100%",
  },
  paper: {
    zIndex: 999,
    minWidth: "90%",
    maxWidth: "90%",
    outline: "none",
    position: "absolute",
    borderRadius: "16px",
    backgroundColor: COLORS.white,
  },
};

export default styles;
